import { IApplicationState } from '../../types/redux';

export const selectCpdLandingUrl = (state: IApplicationState) => {
  const isAvailable = state.cpd.isAvailable;

  if (!isAvailable) {
    return null;
  }

  return state.cpd.cpdLandingUrl;
};
